export default __webpack_public_path__ + "static/media/motivations.b3a91ff1.wav";